module.exports = "/images/vendor/trumbowyg/dist/ui/icons.svg?8581d13665deeae4a07bb4f6a6a9799c";